var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"service-detail-page"},[_c('div',{staticClass:"main-wrap left-wrap"},[_c('div',{staticClass:"left-view",style:(_vm.leftStyle||{})},[_vm._t("left")],2)]),_c('div',{staticClass:"main-wrap right-view",style:(_vm.rightStyle||{})},[_vm._t("right")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }